export function PayrollSettingsPage () {
  return (
    <div className='p-6'>
      <h2 className='heading-md'>Payroll</h2>
    </div>
  )
}
